import React from 'react';

export default function ManualEntryForm({ manualInput, setManualInput, onSubmit }) {
  return (
    <div>
      <form onSubmit={onSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Enter Barcode Number</label>
          <input
            type="text"
            value={manualInput}
            onChange={(e) => setManualInput(e.target.value)}
            placeholder="e.g., 9780143129486"
            className="w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            autoFocus
            data-testid="manual-barcode-input"
          />
          <p className="mt-2 text-xs text-gray-500">Enter 10, 12, or 13 digits (no spaces or dashes)</p>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          data-testid="manual-submit-btn"
        >
          Check Prices
        </button>
      </form>

      <div className="mt-4 bg-gray-50 border border-gray-200 rounded-lg p-4">
        <h3 className="font-semibold text-gray-900 mb-2 text-sm">Supported Formats:</h3>
        <ul className="text-xs text-gray-600 space-y-1">
          <li><strong>EAN-13:</strong> 13 digits (most DVDs, CDs, games)</li>
          <li><strong>ISBN-13:</strong> 13 digits starting with 978/979 (books)</li>
          <li><strong>ISBN-10:</strong> 10 digits (older books)</li>
          <li><strong>UPC-A:</strong> 12 digits (US products)</li>
        </ul>
      </div>
    </div>
  );
}
